import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'dnd' */ './dndLoad');
};
const L = GetLoadables(loader, [
    'Draggable',
    'Rnd'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './dndLoad'
// #endif
export let { Draggable, Rnd } = L;
